export class Upvotes {
  public id: number;
  public geometryId: number;
  public ipAddress: string;
  public comment: string;
}
